import React from 'react'
import {useState, useRef, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { startWindow, showWindow, hideWindow, focusWindow, fullScreen, closeWindow, showStartMenu, hideStartMenu } from '../slices/mwSelectSlice';
import Draggable from "react-draggable";
import StartMenuButton from './StartMenuButton';

function useOutsideAlerter(ref) {
    const dispatch = useDispatch()
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (!event.target.classList.contains('startButton') && ref.current && !ref.current.contains(event.target)) {
            dispatch(hideStartMenu())
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }


const StartMenu = () =>{
    const startMenuVis = useSelector((state) => state.shower.startMenu);
    const ref = useRef()
    useOutsideAlerter(ref);
    const startMenuButtons = [
        'canvas-window',
        //'feed-window',
        //'vis-window',
        'webcam-window',
        //'media-window',
    ]
    const canvasLogo = require('../img/hamster.png')
    const feedLogo = require('../img/feed_logo.jpg')
    const dogLogo = require('../img/dog.png')
    const mediaLogo = require('../img/media.png')
    const webcamLogo = require('../img/webcam.png')

    const setMenu = (id) => {
        if(id === 'canvas-window'){
          return canvasLogo
        }else if(id === 'feed-window'){
          return feedLogo
        }else if(id === 'vis-window'){
          return dogLogo
        }else if(id === 'media-window'){
          return mediaLogo
        }else if(id === 'webcam-window'){
            return webcamLogo
        }
        
    }
    /*
        source : https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
    */

    return(
        <div ref={ref} style={{
            zIndex: '9999',
            display: startMenuVis ? 'flex' : 'none',
            flexFlow: 'column',
            width: '15%',
            height: '45%',
            left:'0%',
            top:'51.22%',
            position: 'absolute'
        }}>
            <div className='startHandle' style={{
                width: '100%',
                height: '15%',
                //left: '0%',
                //top: '0%',
                backgroundColor: 'rgb(76, 201, 240)',
                position: 'relative',
                alignItems: 'flex-end',
                border: '2px outset rgb(76, 201, 240)',
                borderTopRightRadius: '25px',
                borderTopLeftRadius: '10px',
                overflow: 'clip'
            }}>
                <p
                style={{
                    fontFamily: '"Terminal", monospace',
                    fontSmooth: 'never',  
                    fontSize: '2vh',
                    paddingLeft: '25%',
                    verticalAlign: 'center',
                    position: 'relative',
                    //alignItems: 'flex-end',
                    textAlign: 'right',
                    paddingRight: '5%',
                }}>
                    meow_os    
                </p>
            </div>

            <div className='startBody' style={{
                width: '100%',
                height: '100%',
                //left: '0%',
                //top: '5%',
                display: 'flex',
                flexFlow: 'column',
                backgroundColor: 'rgb(235, 186, 164)',
                position: 'relative',
                border: '2px outset rgb(235, 186, 178)',
                borderBottomRightRadius: '25px',
            }}>
                {
                    startMenuButtons.map((qb) => 
                        <StartMenuButton key={qb} windowID={qb} logo={setMenu(qb)}> 

                        </StartMenuButton>
                    )
                }
                
            </div>
        </div>
    )
}

export default StartMenu